export const   ADD_APP = 'ADD_APP';
export const   ADD_APP_SUCCESS = 'ADD_APP_SUCCESS';
export const   ADD_APP_ERROR = 'ADD_APP_ERROR';

export const   GET_APPS = 'GET_APPS';
export const   GET_APPS_SUCCESS = 'GET_APPS_SUCCESS';
export const   GET_APPS_ERROR = 'GET_APPS_ERROR';

export const   UPDATE_APPS_COMMUNITY = 'UPDATE_APPS_COMMUNITY';
export const   UPDATE_APPS_COMMUNITY_SUCCESS = 'UPDATE_APPS_COMMUNITY_SUCCESS';
export const   UPDATE_APPS_COMMUNITY_ERROR = 'UPDATE_APPS_COMMUNITY_ERROR';

export const   UPDATE_APPS_RESIDENT = 'UPDATE_APPS_RESIDENT';
export const   UPDATE_APPS_RESIDENT_SUCCESS = 'UPDATE_APPS_RESIDENT_SUCCESS';
export const   UPDATE_APPS_RESIDENT_ERROR = 'UPDATE_APPS_RESIDENT_ERROR';

export const   UPDATE_APPS = 'UPDATE_APPS';
export const   UPDATE_APPS_SUCCESS = 'UPDATE_APPS_SUCCESS';
export const   UPDATE_APPS_ERROR = 'UPDATE_APPS_ERROR';